import React from 'react';
import { motion } from 'framer-motion';
import { WhatsApp, LocationOn, Phone, Email } from '@mui/icons-material';

const contactItems = [
  {
    Icon: LocationOn,
    title: 'Location',
    content: 'Avonlea, Harare, Zimbabwe'
  },
  {
    Icon: Phone,
    title: 'Phone',
    content: '+263 714 574 400',
    content2: '+263 772 574 400'
  },
  {
    Icon: Email,
    title: 'Email',
    content: 'info@bizani.co.zw',
    href: 'mailto:info@bizani.co.zw'
  },
  {
    Icon: WhatsApp,
    title: 'WhatsApp',
    content: 'Chat with us on WhatsApp',
    href: 'https://wa.me/263714574400'
  }
];

const ContactInfo: React.FC = () => {
  return (
    <motion.div
      initial={{ opacity: 0, x: -30 }}
      whileInView={{ opacity: 1, x: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8 }}
    >
      <h2 className="text-3xl md:text-4xl font-headline font-bold text-white mb-8" style={{ color: '#EF3F23' }}>
        Contact Information
      </h2>
      <div className="space-y-4">
        {contactItems.map((item, index) => {
          const Icon = item.Icon;
          const Wrapper = item.href ? 'a' : 'div';
          const isMailto = item.href?.startsWith('mailto:');
          const wrapperProps = item.href
            ? isMailto
              ? { href: item.href, className: 'block' }
              : { href: item.href, target: '_blank' as const, rel: 'noopener noreferrer', className: 'block' }
            : { className: '' };
          return (
            <motion.div
              key={item.title}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.08 }}
              className="rounded-xl border border-gray-800 bg-gray-900/50 p-5 hover:border-bizani-orange/50 transition-colors duration-300"
            >
              <Wrapper {...wrapperProps}>
                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0 w-12 h-12 rounded-full bg-bizani-orange/20 flex items-center justify-center">
                    <Icon style={{ color: '#EF3F23', fontSize: 24 }} />
                  </div>
                  <div>
                    <h3 className="font-headline font-semibold text-white mb-1">{item.title}</h3>
                    <p className="text-gray-400 font-body text-sm">{item.content}</p>
                    {item.content2 && (
                      <p className="text-gray-400 font-body text-sm">{item.content2}</p>
                    )}
                  </div>
                </div>
              </Wrapper>
            </motion.div>
          );
        })}
      </div>
    </motion.div>
  );
};

export default ContactInfo;
